import { CampsiteBrandBar } from "@/components/branding/CampsiteBrandBar";
import { useBranding } from "@/lib/branding/useBranding";
import type { TouristPanelDeviceStatus } from "@/types/touristPanel";

type Props = {
  status: TouristPanelDeviceStatus | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
};

export function TouristPanelDevicePendingScreen({ status, loading, error, onRetry }: Props) {
  const { siteName, logoUrl } = useBranding();
  const isRevoked = status?.status === "revoked";

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-6 text-center">
      <CampsiteBrandBar siteName={siteName} logoUrl={logoUrl} />
      <div className="max-w-lg rounded-xl border border-separator bg-fill-quaternary p-8">
        <h1 className="mb-3 text-2xl font-semibold">
          {isRevoked ? "Gerät gesperrt" : "Freischaltung erforderlich"}
        </h1>

        {loading && !status ? (
          <p className="text-lg text-label-secondary">Gerät wird registriert…</p>
        ) : null}

        {status ? (
          <>
            <p className="text-lg text-label-secondary">{status.message}</p>
            <dl className="mt-6 space-y-3 rounded-xl bg-fill/30 p-4 text-left text-sm">
              <div>
                <dt className="text-label-tertiary">Panel-Arbeitsplatz</dt>
                <dd className="font-medium">{status.workstation_label}</dd>
              </div>
              <div>
                <dt className="text-label-tertiary">Geräte-Kennung (für Admin)</dt>
                <dd>
                  <code className="rounded bg-fill px-2 py-1 text-base tracking-wide">
                    {status.device_token_short}
                  </code>
                </dd>
              </div>
            </dl>
            {!isRevoked ? (
              <p className="mt-4 text-sm text-label-tertiary">
                Ein Administrator kann dieses Gerät unter Stammdaten → Schnittstellen → Tourist-Import → Geräte
                freischalten. Diese Seite aktualisiert sich automatisch nach der Freigabe.
              </p>
            ) : null}
          </>
        ) : null}

        {error ? (
          <p className="mt-4 text-sm text-red-600" role="alert">
            {error}
          </p>
        ) : null}

        <button type="button" className="mt-6 text-sm text-accent underline" onClick={() => void onRetry()}>
          Erneut versuchen
        </button>
      </div>
    </div>
  );
}
